<template>
	<div style="background-color: #FFFFFF;display: flex;flex-wrap: wrap;">
		<div style="width: 238px;border: 1px solid #f2f2f2;cursor:pointer;" v-for="(item,index) in data"
			@click="onClick(item)">
			<div class="padding-lg" style="border-bottom: 1px solid #f2f2f2;">
				<img :src="item.coverImg+'?x-oss-process=image/resize,h_200,w_200'" style="width: 200px;height: 200px;" :title="item.title">
			</div>
			<div class="padding-sm">
				<div class="text-black" :title="item.title">
					{{item.title}}
				</div>
				<div style="display: flex;align-items: center;">
					<div style="font-size: 22px;color: #FF2D55;">¥{{ item.price | numFilter}}</div>
					<div class="text-gray"
						style="font-size: 12px;margin-left: 5px;text-decoration:line-through">
						批发价:¥{{item.originalPrice | numFilter}}</div>
				</div>
				<div class="text-gray text-df" style="overflow: hidden;white-space: nowrap;
				text-overflow: ellipsis;display: flex;justify-content:space-between;">
					<span style="text-align: left;">
						<span v-if="item.styleId==1">国内贸易</span>
						<span v-if="item.styleId==2">完税进口</span>
						<span v-if="item.styleId==3">香港直邮</span>
						<span v-if="item.styleId==4">保税区直供</span>
						<span v-if="item.styleId==5">海外直邮</span>
					</span>
					<span style="text-align: right;">月进货门店 {{item.sales}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "order_item",
	props: {
		data: [],
	},
	data() {
		return {
			userId: this.$cookie.get('userId')
		}
	},
	filters: {
	  numFilter (value) {
	    let realVal = ''
	    if (!isNaN(value) && value!== '') {
	      // 截取当前数据到小数点后三位
	      let tempVal = parseFloat(value).toFixed(3)
	      realVal = tempVal.substring(0, tempVal.length - 1)
	    } else {
	      realVal = '--'
	    }
	    return realVal
	  }
	},
	mounted() {
	},
	methods:{
	  onClick(e){
		this.$router.push({
			path: '/goodsDet?id='+e.id
		})
	  }
	}
}
</script>

<style scoped>
	.wrap {
		display: flex;
		flex-wrap: wrap;
		width: 1200px;
	}
	.box {
		width: 20%;
		/* height: 320px; */
		padding: 20px;
		background: #fff;
		border: 1px solid #F6F5F7;
		box-sizing: border-box;
		margin-bottom: 20px;
	}
	img {
		width: 200px;
		height: 200px;
	}
	.title {
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		overflow: hidden;
	}
	.price {
		font-weight: 700;
		color: #ff2d55;
		font-size: 22px;
	}
	.text-black {
		overflow: hidden;
		font-size: 16px;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}
</style>



// WEBPACK FOOTER //
// src/components/goods-item.vue